<div class="flex p-3 gap-2 bg-white justify-between rounded-sm">
  <div
    class="h-6 w-6 shrink-0 bg-neutral-20 rounded flex items-center justify-center"
  >
    <span class="svg-icons icon-case icon-16 flex"></span>
  </div>
  <div class="min-w-0 flex-1 flex flex-col gap-y-1">
    <a
      kendoTooltip
      class="text-link text-body bold line-clamp-2 w-fit max-w-full"
      [href]="deepLink()"
      [attr.aria-label]="case().subject"
      [callout]="false"
      [tooltipTemplate]="tooltipTemplate"
      [title]="
        'outlook.buttons.openInMaximizerTooltip'
          | translate: { entry: 'case' | translateVertical }
      "
      target="_blank"
      rel="noopener"
      [innerHTML]="
        case().subject
          | highlightSearchText: outlookStore.relatedSearchPhrase() ?? ''
      "
    ></a>
    <p
      class="caption line-clamp-1"
      [innerHTML]="
        case().abEntry.companyName
          | highlightSearchText: outlookStore.relatedSearchPhrase() ?? ''
      "
    ></p>
    @if (case().status) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ 'outlook.case.status' | translate }}: {{ case().status }}
      </p>
    }
    @if (case().priority) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ 'outlook.case.priority' | translate }}: {{ case().priority }}
      </p>
    }
    @if (case().caseNumber) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ 'case' | translateVertical }}:
        {{ case().caseNumber }}
      </p>
    }
    @if (case().contact?.firstName || case().contact?.lastName) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ 'outlook.case.contact' | translate }}:
        <span
          [innerHTML]="
            case().contact?.firstName + ' ' + case().contact?.lastName
              | highlightSearchText: outlookStore.relatedSearchPhrase() ?? ''
          "
        >
        </span>
      </p>
    }
    @let assignedTo = case().assignedTo;
    @if (assignedTo) {
      <ng-container
        *ngTemplateOutlet="
          personBlock;
          context: {
            label: 'outlook.case.assignedTo' | translate,
            person: assignedTo,
          }
        "
      ></ng-container>
    }
  </div>
  <span
    kendoTooltip
    class="h-fit shrink-0"
    [callout]="false"
    [tooltipTemplate]="tooltipTemplate"
    [title]="saveTooltipMessage"
  >
    <button
      kendoButton
      id="outlook-case-ui-caseCard-saveEmail-{{ case().caseNumber }}"
      themeColor="primary"
      fillMode="flat"
      [disabled]="isSaveDisabled"
      (click)="save.emit(case().key)"
      [iconClass]="saveIconClass"
    ></button>
  </span>
</div>

<ng-template #personBlock let-label="label" let-person="person">
  <div>
    <p class="text-body py-1">{{ label }}:</p>
    <div class="flex items-center">
      <span class="avatar avatar-xs">{{ person.display | nameInitials }}</span>
      <p class="text-body pl-1">{{ person.display }}</p>
    </div>
  </div>
</ng-template>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
